module.exports = __webpack_public_path__ + "img/0Q3B3814-26_H_BlackMatted_MockedUp.f31cd782.jpg";